"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FilePickerModal = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _reactstrap = require("reactstrap");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _FilePickerModal = require("./FilePickerModal.styled");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var FilePickerModal = exports.FilePickerModal = function FilePickerModal(_ref) {
  var _file$name;
  var display = _ref.display,
    id = _ref.id,
    dataTestId = _ref.dataTestId,
    caption = _ref.caption,
    maxSizeMB = _ref.maxSizeMB,
    supportedMediaTypes = _ref.supportedMediaTypes,
    mediaTypesDescription = _ref.mediaTypesDescription,
    onSubmit = _ref.onSubmit,
    onCancel = _ref.onCancel;
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    fileTooLarge = _useState2[0],
    setFileTooLarge = _useState2[1];
  var _useState3 = (0, _react.useState)(null),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    file = _useState4[0],
    setFile = _useState4[1];
  var maxSizeBytes = 1048576 * maxSizeMB;
  var hasFileName = file === null || file === void 0 || (_file$name = file.name) === null || _file$name === void 0 ? void 0 : _file$name.length;
  var onFileChange = /*#__PURE__*/function () {
    var _ref2 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee(e) {
      var file;
      return _regenerator["default"].wrap(function (_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            e.preventDefault();
            if (fileTooLarge) {
              setFileTooLarge(false);
            }
            file = e.target.files[0];
            if (file && file.size > maxSizeBytes) {
              setFileTooLarge(true);
              setFile(null);
            } else if (file) {
              setFile(file);
            }
          case 1:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function onFileChange(_x) {
      return _ref2.apply(this, arguments);
    };
  }();
  return /*#__PURE__*/_react["default"].createElement(_reactstrap.Modal, {
    isOpen: display
  }, /*#__PURE__*/_react["default"].createElement(_FilePickerModal.CustomModalBody, null, /*#__PURE__*/_react["default"].createElement(_FilePickerModal.Wrapper, null, /*#__PURE__*/_react["default"].createElement(_FilePickerModal.StyledCaption, null, caption), /*#__PURE__*/_react["default"].createElement(_FilePickerModal.FileInputWrapper, null, /*#__PURE__*/_react["default"].createElement(_FilePickerModal.FileInputLabel, {
    htmlFor: id
  }, "Choose file", /*#__PURE__*/_react["default"].createElement(_FilePickerModal.StyledFileInput, {
    className: fileTooLarge ? 'is-invalid' : '',
    type: "file",
    id: id,
    onChange: onFileChange,
    accept: supportedMediaTypes === null || supportedMediaTypes === void 0 ? void 0 : supportedMediaTypes.toString(),
    "data-testid": dataTestId
  })), /*#__PURE__*/_react["default"].createElement(_FilePickerModal.FileNameLabel, {
    fileTooLarge: fileTooLarge
  }, (file === null || file === void 0 ? void 0 : file.name) || (fileTooLarge ? 'Selected file is too large' : 'No file chosen'))), /*#__PURE__*/_react["default"].createElement(_FilePickerModal.AllowedMediaTypes, null, mediaTypesDescription), /*#__PURE__*/_react["default"].createElement(_FilePickerModal.ControlButtonsWrapper, null, /*#__PURE__*/_react["default"].createElement(_FilePickerModal.UploadButton, {
    onClick: function onClick(e) {
      e.preventDefault();
      onSubmit(file);
    },
    "data-testid": "file-picker-upload-btn",
    disabled: !hasFileName || fileTooLarge
  }, "Upload"), /*#__PURE__*/_react["default"].createElement(_FilePickerModal.CancelButton, {
    onClick: function onClick(e) {
      e.preventDefault();
      onCancel();
    },
    "data-testid": "file-picker-cancel-btn",
    color: "light",
    variant: "outlined"
  }, "Cancel")))));
};
FilePickerModal.propTypes = {
  display: _propTypes["default"].bool,
  id: _propTypes["default"].string,
  dataTestId: _propTypes["default"].string,
  caption: _propTypes["default"].string,
  maxSizeMB: _propTypes["default"].number,
  supportedMediaTypes: _propTypes["default"].string,
  mediaTypesDescription: _propTypes["default"].string,
  onSubmit: _propTypes["default"].func.isRequired,
  onCancel: _propTypes["default"].func.isRequired
};
FilePickerModal.defaultProps = {
  caption: 'Upload an image',
  maxSizeMB: 5,
  supportedMediaTypes: '.png, .jpeg, .jpg, .gif, .bmp',
  mediaTypesDescription: 'jpeg, png, bmp, gif (5mb file size limit) Images can be no larger than 1920x1080px'
};